import BackgroundElement from './BackgroundElement';
import BackgroundElementDefinition from './BackgroundElementDefinition';
import BackgroundElementMetaData from './BackgroundElementMetaData';

export default {
  BackgroundElement: BackgroundElement,
  BackgroundElementDefinition: BackgroundElementDefinition,
  BackgroundElementType: BackgroundElementMetaData.type,
  BackgroundElementId: BackgroundElementMetaData.id
};
